import getQueryString from '../plugin/parseUrl'
import fetch from '../plugin/axios/fetch.js'

export function urlTokenAuth (next) {
  const token = getQueryString(location.href, 'sacToken') || sessionStorage.getItem('NEW-GENERATION-API-TOKEN')
  const channel = getQueryString(location.href, 'channel')
  localStorage.setItem('FREIGHT-TOKEN', token)
  localStorage.setItem('NEW-GENERATION-API-TOKEN', token)
  localStorage.setItem('NEW_BATCH_TOKEN', token)
  if (token) {
    fetch.setToken(token)
    next()
  } else {
    // 官网移动端渠道运费时效允许免登录使用
    if (['OFFICIAL_WEB_MOBILE'].includes(channel)) {
      next()
    }
  }
}
